import { createAction } from 'redux-actions';

export interface setPaymentTypeAction {
	payload: {
		action: types.redux.api.paymentType.action;
	};
}

export const setPaymentType: any = createAction('SET_PAYMENT_TYPE', (action: setPaymentTypeAction) => action);

export const clearPaymentType: any = createAction('CLEAR_PAYMENT_TYPE');
